module.exports = __webpack_public_path__ + "assets/img/index-banner4-2.8ef17e2f.png";